import { useQuery } from '@tanstack/react-query';
import { questionnaireViewerService } from '../services/questionnaireViewerService';

export const useQuestionnaireViewer = (eventUId?: string) => {
  const questionsQuery = useQuery({
    queryKey: ['viewer-questions', eventUId],
    queryFn: ({ signal }) => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return questionnaireViewerService.getPesquisa(eventUId!, signal);
    },
    enabled: !!eventUId,
  });

  const responsesQuery = useQuery({
    queryKey: ['viewer-responses', eventUId],
    queryFn: ({ signal }) => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return questionnaireViewerService.getRespostas(eventUId!, signal);
    },
    enabled: !!eventUId,
  });

  return {
    questions: questionsQuery.data || [],
    responses: responsesQuery.data || [],
    isLoading: questionsQuery.isLoading || responsesQuery.isLoading,
    error: questionsQuery.error || responsesQuery.error,
  };
};
